/**
 * Vision freemium quota display — mirrors backend/services/feature_gate.py limits.
 * Free: 3 active Visions; Pro / Pro+: unlimited.
 */

export function formatVisionQuota(permissions) {
  const tier = permissions?.tier || 'free';
  const used = Number(permissions?.active_vision_count) || 0;
  const max = permissions?.max_visions ?? 3;

  if (max < 0) {
    const tierLabel =
      tier === 'pro_plus' ? 'Pro+' : tier === 'pro' ? 'Pro' : 'Pro';
    return {
      label: `Unlimited (${tierLabel})`,
      used,
      max: null,
      atLimit: false,
      isUnlimited: true,
    };
  }

  return {
    label: `Visions: ${used} of ${max} used (free)`,
    used,
    max,
    atLimit: Boolean(permissions?.at_vision_limit),
    isUnlimited: false,
  };
}
